module.exports = __webpack_public_path__ + "img/darkrose.9c87113b.png";